<script>
import { sceneAssets } from '@/config'

export default {

  data () {
    return {
      sceneAssets
    }
  },

  mounted () {
    this.$el.addEventListener('loaded', this.onAllAssetsLoaded)
  },

  beforeDestroy () {
    this.$el.removeEventListener('loaded', this.onAllAssetsLoaded)
  },

  methods: {

    onAllAssetsLoaded () {
      this.$emit('loaded')
    }

  }

}
</script>

<template>
  <a-assets
    v-on="$listeners"
  >
    <a-asset-item
      v-for="(src, id) in sceneAssets"
      :id="id"
      :key="id"
      :src="src"
      :response-type="src.indexOf('.glb' > 0) || src.indexOf('.gltf' > 0) ? 'arraybuffer' : undefined"
    />
  </a-assets>
</template>
